<div class="alert alert-incomplete alert-dismissible"
     role="alert">
    <button type="button"
            class="btn-close"
            data-dismiss="alert"
            aria-label="Close">
    </button>{{message}}
</div>
